var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14C11 13.4477 11.4477 13 12 13V13C12.5523 13 13 13.4477 13 14V15C13 15.5523 13.4477 16 14 16H15C15.5523 16 16 15.5523 16 15V11.3746C16 11.1677 16.1677 11 16.3746 11V11C16.714 11 16.8785 10.5848 16.6312 10.3524L12.6941 6.65228C12.3054 6.28701 11.6985 6.29107 11.3147 6.66151L7.42488 10.4164C7.20524 10.6284 7.35533 11 7.6606 11V11C7.84804 11 8 11.152 8 11.3394V15C8 15.5523 8.44772 16 9 16H10C10.5523 16 11 15.5523 11 15V14ZM11.5939 1.18051C11.8524 1.06559 12.1476 1.06559 12.4061 1.18051L20.4061 4.73606C20.7673 4.89656 21 5.25468 21 5.64987V11C21 16.4648 17.277 21.5805 12.2367 22.9392C12.0818 22.981 11.9182 22.981 11.7633 22.9392C6.72298 21.5805 3 16.4648 3 11V5.64987C3 5.25468 3.23273 4.89656 3.59386 4.73606L11.5939 1.18051Z",
    stroke: "#292929",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.e68ab89b26c76f9a758ffb35b24fd96c.svg";
export { ForwardRef as ReactComponent };